import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../common/ModelSave";
import { CancelButton, SaveButton } from "../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [data, setData] = useState({});

  const GetEditData = async () => {
    const response = await getData(`/employee/seller/${id}`);
    reset(response?.data);
    setData(response?.data);
    console.log("response?.data", response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const d = new FormData();
      d.append("commission", data?.commission);
      d.append("commission_s_date", data?.commission_s_date);
      d.append("commission_e_date", data?.commission_e_date);
      const response = await postData(`/employee/seller/commission/${id}`, d);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  console.log("data", data);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit {data?.first_name}'s Commission
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="text-center">
                        <Form.Label>Commission</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          min={0}
                          max={70}
                          name="commission"
                          placeholder="Commission"
                          className={classNames("", {
                            "is-invalid": errors?.commission,
                          })}
                          {...register("commission", {
                            required: "Commission is required",
                            validate: (value) => {
                              if (!value) return "Commission is required";
                              // Validate percentage discount
                              if (parseFloat(value) < 1) {
                                return "Commission should not be less then 1";
                              }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.commission && (
                        <span className="text-danger">
                          {errors.commission.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group>
                      <div className="text-center">
                        <Form.Label>Commission Start Date</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          name="commission_s_date"
                          placeholder="Commission Start Date"
                          className={classNames("", {
                            "is-invalid": errors?.commission_s_date,
                          })}
                          {...register("commission_s_date", {
                            required: "Commission Start Date is required",
                            validate: (value) => {
                              if (!value)
                                return "Commission Start Date is required";

                              const selectedDate = new Date(value);
                              const today = new Date();

                              // Check if the selected date is less than today
                              if (selectedDate < today.setHours(0, 0, 0, 0)) {
                                return "Commission Start Date cannot be in the past";
                              }

                              return true; // Return true for valid input
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.commission_s_date && (
                        <span className="text-danger">
                          {errors.commission_s_date.message}
                        </span>
                      )}
                    </Form.Group>

                    <Form.Group>
                      <div className="text-center">
                        <Form.Label>Commission End Date</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          name="commission_e_date"
                          placeholder="Commission End Date"
                          className={classNames("", {
                            "is-invalid": errors?.commission_e_date,
                          })}
                          {...register("commission_e_date", {
                            required: "Commission End Date is required",
                            validate: (value) => {
                              if (!value)
                                return "Commission End Date is required";

                              const startDate = new Date(
                                watch("commission_s_date")
                              );
                              const endDate = new Date(value);

                              if (endDate < startDate) {
                                return "Commission End Date cannot be before the Commission Start Date";
                              }

                              return true; // Return true for valid input
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.commission_e_date && (
                        <span className="text-danger">
                          {errors.commission_e_date.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
